import { withStyles, WithStyles, Grid, Button, Theme } from '@material-ui/core'
import { goBack } from 'connected-react-router'
import { FC } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { reduxForm } from 'redux-form'
import { navigate } from '../../actions/routes'
import { addShowingToFieldArray } from '../../actions/showings'
import { Navigate } from '../../actions/types'
import { selectApartmentById } from '../../selectors/apartments'
import {
  selectLocationPathname,
  selectContentIdFromPathname,
  selectUserIdFromPathname
} from '../../selectors/router'
import { Apartment } from '../../types/apartments'
import { ReduxForm } from '../../types/forms'
import { AddShowingsFormData } from '../../types/showings'
import { StateInterface } from '../../types/states'
import { bindSubmitActionToPromise } from '../../utils/forms'

interface StateProps {
  pathname: string
  userId?: string
  apartmentId?: string
  apartment?: Apartment
}
interface DispatchProps {
  navigate: Navigate
  goBack: () => void
  addShowingToFieldArray: (formData: AddShowingsFormData) => void
}

type ComponentProps = StateProps &
  DispatchProps &
  WithTranslation &
  WithStyles &
  ReduxForm

const styles = ({ palette }: Theme) => ({
  container: {
    padding: '1rem',
    borderBottom: '1px solid ' + palette.grey[100]
  },
  primaryBtn: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  }
})

const SubNavigation: FC<ComponentProps> = ({
  classes,
  navigate,
  goBack,
  t,
  pathname,
  userId,
  apartmentId,
  apartment,
  handleSubmit,
  addShowingToFieldArray
}) => {
  return (
    <Grid container justify='space-between' className={classes.container}>
      <Button variant='outlined' onClick={() => goBack()}>
        {t('navigation.sub.back')}
      </Button>
      {pathname.includes('/applications') && userId && apartmentId && (
        <Button
          className={classes.primaryBtn}
          color='primary'
          variant='contained'
          onClick={() =>
            navigate(`/users/${userId}/apartments/${apartmentId}/overview`)
          }
        >
          {t('navigation.sub.overview')}
        </Button>
      )}
      {pathname.includes('/overview') && userId && apartment && (
        <Button
          color='primary'
          variant='contained'
          className={classes.primaryBtn}
          onClick={() =>
            navigate(`/users/${userId}/apartments/${apartmentId}/applications`)
          }
        >
          {t('navigation.sub.applicants')}
        </Button>
      )}
    </Grid>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)

  return {
    pathname: selectLocationPathname(state),
    userId: selectUserIdFromPathname(state),
    apartmentId,
    apartment: apartmentId ? selectApartmentById(apartmentId)(state) : undefined
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  navigate: (path: string) => dispatch(navigate(path)),
  goBack: () => dispatch(goBack()),
  addShowingToFieldArray: bindSubmitActionToPromise(
    dispatch,
    addShowingToFieldArray
  )
})

export default connect<StateProps, DispatchProps, unknown, StateInterface>(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'AddShowingsForm'
  })(withTranslation()(withStyles(styles)(SubNavigation) as any) as any)
)
